import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { visitsApi } from '../../api/lib/visits';
import { attachmentsKeys } from '../../api/query-keys/attachments';

import { ApiError } from '@/types/interfaces/api-error';

export const useDeleteAttachment = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ visitId, attachmentId }: { visitId: number; attachmentId: number }) =>
      visitsApi.removeAttachment(visitId, attachmentId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: attachmentsKeys.lists(),
      });

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
